module.exports = __webpack_public_path__ + "img/dotpoints-01.757d3bea.svg";